import { ContactState } from './types';

export const state = (): ContactState => initialState();

export const initialState = (): ContactState => ({
  contacts: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: -1,
        itemsPerPage: -1,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: [],
    },
  },
});
